import type { FC } from "react";
import styled from "@emotion/styled";
import { renderSmartCard, type RenderSmartCardOptions } from "@/components/heads-up/cards";
import type { SmartCardRow } from "@/domains/database";

interface Props {
  cards: SmartCardRow[];
  cardRenderOptions: RenderSmartCardOptions;
}

export const HeadsUpContentView: FC<Props> = ({ cards, cardRenderOptions }) => {
  return (
    <CardList>
      {cards.map(card => {
        const content = renderSmartCard(card, cardRenderOptions);

        if (!content) return null;

        return (
          <CardItem key={card.id}>
            <CardContent>{content}</CardContent>
          </CardItem>
        );
      })}
    </CardList>
  );
};

const CardList = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;
